export default __webpack_public_path__ + "static/media/agms 2.9be78e95.svg";